import { Spin } from 'antd';
import './App.css';
import AppRoutes from './routes/AppRoutes';
import { useSelector } from 'react-redux';
import { RootState } from './app/store';
import { useTranslation } from 'react-i18next';

function App() {
  const { isLoading } = useSelector((state: RootState) => state.loading);
  const { i18n } = useTranslation();
  const currLang = i18n.language; // Current language
  const classOut = currLang === "lo" ? "App laoLang" : "App engLang";

  return (
    <div className={classOut}>
      <Spin className='loading-spinner-container' spinning={isLoading}>
        <AppRoutes />
      </Spin>
    </div>
  );
}

export default App;
